/**
 * The roles SegmentController's two GET endpoints admit:
 * @PreAuthorize("hasAnyRole('Accountant', 'InstitutionAdmin')") on both institution/{id} and {id}.
 * Segments are read-only in this product (carried-debt item 11: no create/manage UI or API), so a
 * form for any other role hides its segment picker rather than firing a request that can only 403.
 */
export const SEGMENT_READ_ROLES: string[] = ['Accountant', 'InstitutionAdmin'];

export const canReadSegments = (roles: unknown): boolean => {
  const list: string[] = Array.isArray(roles) ? roles : roles ? [roles as string] : [];
  return list.some(r => SEGMENT_READ_ROLES.includes(r));
};
